<div class="video-wrapper">
  <div class="video-div" [ngStyle]="imageStyle">
    <div class="video-container">
      <video #lightboxVideoPlayer [ngStyle]="objectFit" [poster]="urls.thumbnails.frame1" controls
             controlsList="nodownload" (click)="playVideo()">
        <source [src]="urls.full" type="video/mp4"/>
      </video>
    </div>
  </div>
</div>
